import React from 'react';
import createReactClass from 'create-react-class';
import AsyncValidator from 'async-validator';
import warning from 'warning';
import get from 'lodash/get';
import set from 'lodash/set';
import eq from 'lodash/eq';
import createFieldsStore from './createFieldsStore';
import {
    argumentContainer,
    identity,
    normalizeValidateRules,
    getValidateTriggers,
    getValueFromEvent,
    hasRules,
    getParams,
    isEmptyObject,
    flattenArray,
    supportRef,
} from './utils';
import FieldElemWrapper from './FieldElemWrapper';

const DEFAULT_TRIGGER = 'onChange';

export default function createBaseForm(option: any = {}, mixins: any[] = []) {
    const {
        validateMessages,
        onFieldsChange,
        onValuesChange,
        mapProps = identity,
        mapPropsToFields,
        fieldNameProp,
        fieldMetaProp,
        fieldDataProp,
        formPropName = 'form',
        name: formName,
        withRef,
    } = option;

    return function decorate(WrappedComponent: any) {
        const Form = createReactClass({
            displayName: 'Form',

            mixins,

            getInitialState() {
                const fields = mapPropsToFields && mapPropsToFields(this.props);
                this.fieldsStore = createFieldsStore(fields || {});

                this.instances = {};
                this.cachedBind = {};
                this.clearedFieldMetaCache = {};

                this.renderFields = {};
                this.domFields = {};

                // HACK: https://github.com/ant-design/ant-design/issues/6406
                [
                    'getFieldsValue',
                    'getFieldValue',
                    'setFieldsInitialValue',
                    'getFieldsError',
                    'getFieldError',
                    'isFieldValidating',
                    'isFieldsValidating',
                    'isFieldsTouched',
                    'isFieldTouched',
                ].forEach((key) => {
                    this[key] = (...args: any[]) => {
                        if (process.env.NODE_ENV !== 'production') {
                            warning(
                                false,
                                'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' +
                  'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140'
                            );
                        }
                        return this.fieldsStore[key](...args);
                    };
                });

                return {
                    submitting: false,
                };
            },

            componentDidMount() {
                this.cleanUpUselessFields();
            },

            componentDidUpdate(_prevProps: any) {
                if (mapPropsToFields) {
                    this.fieldsStore.updateFields(mapPropsToFields(this.props));
                }
                this.cleanUpUselessFields();
            },

            onCollectCommon(name: string, action: string, args: any[]) {
                const fieldMeta = this.fieldsStore.getFieldMeta(name);
                if (fieldMeta[action]) {
                    fieldMeta[action](...args);
                } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
                    fieldMeta.originalProps[action](...args);
                }
                const value = fieldMeta.getValueFromEvent
                    ? fieldMeta.getValueFromEvent(...args)
                    : getValueFromEvent(args[0]);
                if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
                    const valuesAll = this.fieldsStore.getAllValues();
                    const valuesAllSet: any = {};
                    valuesAll[name] = value;
                    Object.keys(valuesAll).forEach((key) => set(valuesAllSet, key, valuesAll[key]));
                    onValuesChange(
                        {
                            [formPropName]: this.getForm(),
                            ...this.props,
                        },
                        set({}, name, value),
                        valuesAllSet
                    );
                }
                const field = this.fieldsStore.getField(name);
                return {
                    name,
                    field: {
                        ...field,
                        value,
                        touched: true,
                    },
                    fieldMeta,
                };
            },

            onCollect(name_: string, action: string, ...args: any[]) {
                const { name, field, fieldMeta } = this.onCollectCommon(name_, action, args);
                const { validate } = fieldMeta;
                this.fieldsStore.setFieldsAsDirty();
                const newField = {
                    ...field,
                    dirty: hasRules(validate),
                };
                this.setFields({
                    [name]: newField,
                });
            },

            onCollectValidate(name_: string, action: string, ...args: any[]) {
                const { field, fieldMeta } = this.onCollectCommon(name_, action, args);
                const newField = {
                    ...field,
                    dirty: true,
                };
                this.fieldsStore.setFieldsAsDirty();
                this.validateFieldsInternal([newField], {
                    action,
                    options: {
                        firstFields: !!fieldMeta.validateFirst,
                    },
                });
            },

            getCacheBind(name: string, action: string, fn: any) {
                if (!this.cachedBind[name]) {
                    this.cachedBind[name] = {};
                }
                const cache = this.cachedBind[name];
                if (!cache[action] || cache[action].oriFn !== fn) {
                    cache[action] = {
                        fn: fn.bind(this, name, action),
                        oriFn: fn,
                    };
                }
                return cache[action].fn;
            },

            getFieldDecorator(name: string, fieldOption?: any) {
                const props = this.getFieldProps(name, fieldOption);
                return (fieldElem: any) => {
                    // We should put field in record if it is rendered
                    this.renderFields[name] = true;

                    const fieldMeta = this.fieldsStore.getFieldMeta(name);
                    const originalProps = fieldElem.props;
                    if (process.env.NODE_ENV !== 'production') {
                        const valuePropName = fieldMeta.valuePropName;
                        warning(
                            !(valuePropName in originalProps),
              `\`getFieldDecorator\` will override \`${valuePropName}\`, ` +
                `so please don't set \`${valuePropName}\` directly ` +
                `and use \`setFieldsValue\` to set it.`
                        );
                        const defaultValuePropName = `default${valuePropName[0].toUpperCase()}${valuePropName.slice(
                            1
                        )}`;
                        warning(
                            !(defaultValuePropName in originalProps),
              `\`${defaultValuePropName}\` is invalid ` +
                `for \`getFieldDecorator\` will set \`${valuePropName}\`,` +
                ` please use \`option.initialValue\` instead.`
                        );
                    }
                    fieldMeta.originalProps = originalProps;
                    fieldMeta.ref = fieldElem.ref;
                    const decoratedFieldElem = React.cloneElement(fieldElem, {
                        ...props,
                        ...this.fieldsStore.getFieldValuePropValue(fieldMeta),
                    });
                    return supportRef(fieldElem) ? (
                        decoratedFieldElem
                    ) : (
                        <FieldElemWrapper name={name} form={this}>
                            {decoratedFieldElem}
                        </FieldElemWrapper>
                    );
                };
            },

            getFieldProps(name: string, usersFieldOption: any = {}) {
                if (!name) {
                    throw new Error('Must call `getFieldProps` with valid name string!');
                }
                if (process.env.NODE_ENV !== 'production') {
                    warning(
                        this.fieldsStore.isValidNestedFieldName(name),
            `One field name cannot be part of another, e.g. \`a\` and \`a.b\`. Check field: ${name}`
                    );
                    warning(
                        !('exclusive' in usersFieldOption),
                        '`option.exclusive` of `getFieldProps`|`getFieldDecorator` had been remove.'
                    );
                }

                delete this.clearedFieldMetaCache[name];

                const fieldOption = {
                    name,
                    trigger: DEFAULT_TRIGGER,
                    valuePropName: 'value',
                    validate: [],
                    ...usersFieldOption,
                };

                const { rules, trigger, validateTrigger = trigger, validate } = fieldOption;

                const fieldMeta = this.fieldsStore.getFieldMeta(name);
                if ('initialValue' in fieldOption) {
                    fieldMeta.initialValue = fieldOption.initialValue;
                }

                const inputProps: any = {
                    ...this.fieldsStore.getFieldValuePropValue(fieldOption),
                    ref: this.getCacheBind(name, `${name}__ref`, this.saveRef),
                };
                if (fieldNameProp) {
                    inputProps[fieldNameProp] = formName ? `${formName}_${name}` : name;
                }

                const validateRules = normalizeValidateRules(validate, rules, validateTrigger);
                const validateTriggers = getValidateTriggers(validateRules);
                validateTriggers.forEach((action: any) => {
                    if (inputProps[action]) return;
                    inputProps[action] = this.getCacheBind(name, action, this.onCollectValidate);
                });

                // make sure that the value will be collect
                if (trigger && validateTriggers.indexOf(trigger) === -1) {
                    inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
                }

                const meta = {
                    ...fieldMeta,
                    ...fieldOption,
                    validate: validateRules,
                };
                this.fieldsStore.setFieldMeta(name, meta);
                if (fieldMetaProp) {
                    inputProps[fieldMetaProp] = meta;
                }
                if (fieldDataProp) {
                    inputProps[fieldDataProp] = this.fieldsStore.getField(name);
                }

                // This field is rendered, record it
                this.renderFields[name] = true;

                return inputProps;
            },

            getFieldInstance(name: string) {
                return this.instances[name];
            },

            getRules(fieldMeta: any, action: string) {
                const actionRules = fieldMeta.validate
                    .filter((item: any) => !action || item.trigger.indexOf(action) >= 0)
                    .map((item: any) => item.rules);
                return flattenArray(actionRules);
            },

            setFields(maybeNestedFields: any, callback?: any) {
                const fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
                this.fieldsStore.setFields(fields);
                if (onFieldsChange) {
                    const changedFields = Object.keys(fields).reduce(
                        (acc, name) => set(acc, name, this.fieldsStore.getField(name)),
                        {}
                    );
                    onFieldsChange(
                        {
                            [formPropName]: this.getForm(),
                            ...this.props,
                        },
                        changedFields,
                        this.fieldsStore.getNestedAllFields()
                    );
                }
                this.forceUpdate(callback);
            },

            setFieldsValue(changedValues: any, callback?: any) {
                const { fieldsMeta } = this.fieldsStore;
                const values = this.fieldsStore.flattenRegisteredFields(changedValues);
                const newFields = Object.keys(values).reduce((acc: any, name) => {
                    const isRegistered = fieldsMeta[name];
                    if (process.env.NODE_ENV !== 'production') {
                        warning(
                            isRegistered,
                            'Cannot use `setFieldsValue` until ' +
                'you use `getFieldDecorator` or `getFieldProps` to register it.'
                        );
                    }
                    if (isRegistered) {
                        const value = values[name];
                        acc[name] = {
                            value,
                        };
                    }
                    return acc;
                }, {});
                this.setFields(newFields, callback);
                if (onValuesChange) {
                    const allValues = this.fieldsStore.getAllValues();
                    onValuesChange(
                        {
                            [formPropName]: this.getForm(),
                            ...this.props,
                        },
                        changedValues,
                        allValues
                    );
                }
            },

            saveRef(name: string, _: any, component: any) {
                if (!component) {
                    const _fieldMeta = this.fieldsStore.getFieldMeta(name);
                    if (!_fieldMeta.preserve) {
                        // after destroy, delete data
                        this.clearedFieldMetaCache[name] = {
                            field: this.fieldsStore.getField(name),
                            meta: _fieldMeta,
                        };
                        this.clearField(name);
                    }
                    delete this.domFields[name];
                    return;
                }
                this.domFields[name] = true;
                this.recoverClearedField(name);
                const fieldMeta = this.fieldsStore.getFieldMeta(name);
                if (fieldMeta) {
                    const { ref } = fieldMeta;
                    if (ref) {
                        if (typeof ref === 'string') {
                            throw new Error(`can not set ref string for ${name}`);
                        } else if (typeof ref === 'function') {
                            ref(component);
                        } else if (Object.prototype.hasOwnProperty.call(ref, 'current')) {
                            ref.current = component;
                        }
                    }
                }
                this.instances[name] = component;
            },

            cleanUpUselessFields() {
                const fieldList = this.fieldsStore.getAllFieldsName();
                const removedList = fieldList.filter((field: string) => {
                    const fieldMeta = this.fieldsStore.getFieldMeta(field);
                    return !this.renderFields[field] && !this.domFields[field] && !fieldMeta.preserve;
                });
                if (removedList.length) {
                    removedList.forEach(this.clearField);
                }
                this.renderFields = {};
            },

            clearField(name: string) {
                this.fieldsStore.clearField(name);
                delete this.instances[name];
                delete this.cachedBind[name];
            },

            resetFields(ns?: any) {
                const newFields = this.fieldsStore.resetFields(ns);
                if (Object.keys(newFields).length > 0) {
                    this.setFields(newFields);
                }
                if (ns) {
                    const names = Array.isArray(ns) ? ns : [ns];
                    names.forEach((name: string) => delete this.clearedFieldMetaCache[name]);
                } else {
                    this.clearedFieldMetaCache = {};
                }
            },

            recoverClearedField(name: string) {
                if (this.clearedFieldMetaCache[name]) {
                    this.fieldsStore.setFields({
                        [name]: this.clearedFieldMetaCache[name].field,
                    });
                    this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
                    delete this.clearedFieldMetaCache[name];
                }
            },

            validateFieldsInternal(fields: any[], { fieldNames, action, options = {} }: any, callback?: any) {
                const allRules: any = {};
                const allValues: any = {};
                const allFields: any = {};
                const alreadyErrors: any = {};
                fields.forEach((field) => {
                    const name = field.name;
                    if (options.force !== true && field.dirty === false) {
                        if (field.errors) {
                            set(alreadyErrors, name, { errors: field.errors });
                        }
                        return;
                    }
                    const fieldMeta = this.fieldsStore.getFieldMeta(name);
                    const newField = {
                        ...field,
                    };
                    newField.errors = undefined;
                    newField.validating = true;
                    newField.dirty = true;
                    allRules[name] = this.getRules(fieldMeta, action);
                    allValues[name] = newField.value;
                    allFields[name] = newField;
                });
                this.setFields(allFields);
                // in case normalize
                Object.keys(allValues).forEach((f) => {
                    allValues[f] = this.fieldsStore.getFieldValue(f);
                });
                if (callback && isEmptyObject(allFields)) {
                    callback(
                        isEmptyObject(alreadyErrors) ? null : alreadyErrors,
                        this.fieldsStore.getFieldsValue(fieldNames)
                    );
                    return;
                }
                const validator = new AsyncValidator(allRules);
                if (validateMessages) {
                    validator.messages(validateMessages);
                }
                validator.validate(allValues, options, (errors: any) => {
                    const errorsGroup = {
                        ...alreadyErrors,
                    };
                    if (errors && errors.length) {
                        errors.forEach((e: any) => {
                            const errorFieldName = e.field;
                            let fieldName = errorFieldName;

                            // Handle using array validation rule.
                            // ref: https://github.com/ant-design/ant-design/issues/14275
                            Object.keys(allRules).some((ruleFieldName) => {
                                const rules = allRules[ruleFieldName] || [];

                                // Exist if match rule
                                if (ruleFieldName === errorFieldName) {
                                    fieldName = ruleFieldName;
                                    return true;
                                }

                                // Skip if not match array type
                                if (
                                    rules.every((_ref2: any) => _ref2.type !== 'array') ||
                  errorFieldName.indexOf(`${ruleFieldName}.`) !== 0
                                ) {
                                    return false;
                                }

                                // Exist if match the field name
                                const restPath = errorFieldName.slice(ruleFieldName.length + 1);
                                if (/^\d+$/.test(restPath)) {
                                    fieldName = ruleFieldName;
                                    return true;
                                }
                                return false;
                            });

                            const field = get(errorsGroup, fieldName);
                            if (typeof field !== 'object' || Array.isArray(field)) {
                                set(errorsGroup, fieldName, { errors: [] });
                            }
                            const fieldErrors = get(errorsGroup, fieldName.concat('.errors'));
                            fieldErrors.push(e);
                        });
                    }
                    const expired: any[] = [];
                    const nowAllFields: any = {};
                    Object.keys(allRules).forEach((name) => {
                        const fieldErrors = get(errorsGroup, name);
                        const nowField = this.fieldsStore.getField(name);
                        // avoid concurrency problems
                        if (!eq(nowField.value, allValues[name])) {
                            expired.push({
                                name,
                            });
                        } else {
                            nowField.errors = fieldErrors && fieldErrors.errors;
                            nowField.value = allValues[name];
                            nowField.validating = false;
                            nowField.dirty = false;
                            nowAllFields[name] = nowField;
                        }
                    });
                    this.setFields(nowAllFields);
                    if (callback) {
                        if (expired.length) {
                            expired.forEach(({ name }) => {
                                const fieldErrors = [
                                    {
                                        message: `${name} need to revalidate`,
                                        field: name,
                                    },
                                ];
                                set(errorsGroup, name, {
                                    expired: true,
                                    errors: fieldErrors,
                                });
                            });
                        }
                        callback(
                            isEmptyObject(errorsGroup) ? null : errorsGroup,
                            this.fieldsStore.getFieldsValue(fieldNames)
                        );
                    }
                });
            },

            validateFields(ns?: any, opt?: any, cb?: any) {
                const pending = new Promise((resolve, reject) => {
                    const { names, options } = getParams(ns, opt, cb);
                    let { callback } = getParams(ns, opt, cb);
                    if (!callback || typeof callback === 'function') {
                        const oldCb = callback;
                        callback = (errors: any, values: any) => {
                            if (oldCb) {
                                oldCb(errors, values);
                            }
                            if (errors) {
                                reject({
                                    errors,
                                    values,
                                });
                            } else {
                                resolve(values);
                            }
                        };
                    }
                    const fieldNames = names
                        ? this.fieldsStore.getValidFieldsFullName(names)
                        : this.fieldsStore.getValidFieldsName();
                    const fields = fieldNames
                        .filter((name: string) => {
                            const fieldMeta = this.fieldsStore.getFieldMeta(name);
                            return hasRules(fieldMeta.validate);
                        })
                        .map((name: string) => {
                            const field = this.fieldsStore.getField(name);
                            field.value = this.fieldsStore.getFieldValue(name);
                            return field;
                        });
                    if (!fields.length) {
                        callback(null, this.fieldsStore.getFieldsValue(fieldNames));
                        return;
                    }
                    if (!('firstFields' in options)) {
                        options.firstFields = fieldNames.filter((name: string) => {
                            const fieldMeta = this.fieldsStore.getFieldMeta(name);
                            return !!fieldMeta.validateFirst;
                        });
                    }
                    this.validateFieldsInternal(
                        fields,
                        {
                            fieldNames,
                            options,
                        },
                        callback
                    );
                });
                pending.catch((e) => {
                    // eslint-disable-next-line no-console
                    if (console.error && process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error(e);
                    }
                    return e;
                });
                return pending;
            },

            isSubmitting() {
                if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
                    warning(
                        false,
                        '`isSubmitting` is deprecated. ' +
              "Actually, it's more convenient to handle submitting status by yourself."
                    );
                }
                return this.state.submitting;
            },

            submit(callback: any) {
                if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
                    warning(
                        false,
                        '`submit` is deprecated. ' +
              "Actually, it's more convenient to handle submitting status by yourself."
                    );
                }
                const fn = () => {
                    this.setState({
                        submitting: false,
                    });
                };
                this.setState({
                    submitting: true,
                });
                callback(fn);
            },

            render() {
        const { wrappedComponentRef, ...restProps } = this.props; // eslint-disable-line
                const formProps: any = {
                    [formPropName]: this.getForm(),
                };
                if (withRef) {
                    if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
                        warning(
                            false,
                            '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' +
                'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140'
                        );
                    }
                    formProps.ref = 'wrappedComponent';
                } else if (wrappedComponentRef) {
                    formProps.ref = wrappedComponentRef;
                }
                const props = mapProps.call(this, {
                    ...formProps,
                    ...restProps,
                });
                return React.createElement(WrappedComponent, props);
            },
        });

        return argumentContainer(Form, WrappedComponent);
    };
}
